import { AdvisorsPaths } from '@src/components/sco/Advisors/paths'
import { IconType } from 'react-icons'
import { LuList, LuRocket } from 'react-icons/lu'

export type MyFoundersSectionKey = 'active' | 'all'

export type MyFoundersNavItem = {
  key: MyFoundersSectionKey
  title: string
  description: string
  href: string
  icon: IconType
}

/** My Founders views, in rail order. Both list active relationships only. */
export const myFoundersNavItems = (paths: AdvisorsPaths): MyFoundersNavItem[] => [
  {
    key: 'active',
    title: 'Active',
    description: 'Founders you advise, most recently active first. Open a conversation or review a profile.',
    href: paths.myFounders,
    icon: LuRocket,
  },
  {
    key: 'all',
    title: 'All founders',
    description: 'Every active founder relationship. Search by name, then open a conversation.',
    href: paths.myFoundersAll,
    icon: LuList,
  },
]
